import { useTranslation } from 'react-i18next';
import { createCheckboxField } from './createCheckboxField';

/**
 * `EquipmentInformations` is a function component that generates a collection of checkbox fields representing various equipment information.
 *
 * @component
 * @returns {Object} - An object containing a `equipmentInformationsFields` property which is an array of field configurations to be used in a form.
 */
const EquipmentInformations = () => {
  const { t } = useTranslation();

  const equipmentInformationsFields = [
    createCheckboxField('equipment', 'television', t),
    createCheckboxField('equipment', 'cable', t),
    createCheckboxField('equipment', 'internet', t)
  ];

  return {
    equipmentInformationsFields
  };
};

export default EquipmentInformations;
